import { ReviewProps } from '../types'

export const filterReviewsBasedOnRating = (
  reviews: ReviewProps[],
  rating: number,
) => reviews.filter(review => review.rating === rating)
